import React, { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './Header.module.css';
import SearchBar from '../../SearchBar/SearchBar';
import Menu from './Menu/Menu';
import { NotificationBell } from '../../Notifications';
import { useLanguage } from '../../../contexts/LanguageContext';

interface HeaderProps {
    toggleSidebar: () => void;
}

const Header: React.FC<HeaderProps> = ({ toggleSidebar }) => {
    const navigate = useNavigate();
    const { t } = useLanguage();
    const [searchQuery, setSearchQuery] = useState('');

    const handleSettings = () => {
        navigate('/settings/profile');
    };

    // #1193: Wire global search bar - navigate to a search results page on Enter.
    // TODO: Connect to backend search API when available. For now, navigates with query param.
    const handleSearch = useCallback((query: string) => {
        const trimmed = query.trim();
        if (!trimmed) return;
        navigate(`/search?q=${encodeURIComponent(trimmed)}`);
    }, [navigate]);

    const handleSearchChange = useCallback((query: string) => {
        setSearchQuery(query);
    }, []);

    // Suppress unused-prop lint while sidebar toggle migrates to the sidebar
    // footer (AB#1675). Kept for backward compat with MainLayout's prop wiring.
    void toggleSidebar;

    return (
        <header className={styles.header}>
            <div className={styles.logoSection}>
                <img src="/assets/icons/layout/logo.png" alt="Devanza" className={styles.logo} />
            </div>
            <div className={styles.rightSection}>
                <div className={styles.searchSection}>
                    {/* #1193: search bar wired to onSearch and onChange. */}
                    <SearchBar
                        placeholder={t('header.search')}
                        showClearButton={true}
                        value={searchQuery}
                        onChange={handleSearchChange}
                        onSearch={handleSearch}
                    />
                </div>
                <NotificationBell />
                <Menu onSettingsClick={handleSettings} />
            </div>
        </header>
    );
};

export default Header;
